import TIMING_BEFORE from 'constants/salon/timingBefore.const';
import NCOB_TYPE_TIME from 'constants/settings/ncobTypeTime.const';

const NCOB_HOURS = Object.freeze({
  [NCOB_TYPE_TIME.threeDays]: {
    id: NCOB_TYPE_TIME.threeDays,
    description: '72 hours',
    hour: '72:00:00',
    int: 72,
    before: TIMING_BEFORE.threeDaysBefore,
  },
  [NCOB_TYPE_TIME.twoDays]: {
    id: NCOB_TYPE_TIME.twoDays,
    description: '48 hours',
    hour: '48:00:00',
    int: 48,
    before: TIMING_BEFORE.twoDaysBefore,
  },
  [NCOB_TYPE_TIME.oneDay]: {
    id: NCOB_TYPE_TIME.oneDay,
    description: '24 hours',
    hour: '24:00:00',
    int: 24,
    before: TIMING_BEFORE.dayBefore,
  },
});

export default NCOB_HOURS;
